
import './style.less'
export default function App () {
    return (
        <div className="loading">Loading&#8230;</div>
    )
}